import {mount} from "svelte";
import App from "./App.svelte";

const app = mount(App, {target: document.getElementById("svelte") as HTMLElement});